/* Creme Castle collection page, Browse and Theme layouts (Oct 2026).
 * - Filter bar, bottom sheet (phone) / dropdown (desktop), sort
 * - "Show more": appends the next 24 via the Section Rendering API, keeps ?shown=n in the URL,
 *   and on Back restores every loaded page and the scroll position
 * - "Earliest delivery" worked out on the shopper's device with CCSlotEngine + ccClock
 *   (same engine and delivery_rule metaobjects as the product page picker)
 */
(function () {
  "use strict";
  var root = document.querySelector(".cc-col");
  if (!root) return;
  var SECTION = root.dataset.section, LAYOUT = root.dataset.layout, AUDIENCE = root.dataset.audience === "true";
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var isDesktop = function () { return window.matchMedia("(min-width: 990px)").matches; };
  var esc = function (t) { return String(t == null ? "" : t).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); };
  var CHEV = '<svg class="cc-ico cc-chev" viewBox="0 0 12 12" aria-hidden="true"><path d="M3 4.5 6 7.5 9 4.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var XICON = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M3.5 3.5l7 7M10.5 3.5l-7 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  /* ---------- state from Liquid ---------- */
  var state = {};
  try { state = JSON.parse($("[data-cc-state]").textContent); } catch (e) { state = { filters: [] }; }
  var F = state.filters || [];
  var find = function (test) { return F.filter(test)[0] || null; };
  var fPrice = find(function (f) { return f.type === "price_range"; });
  var fWeight = find(function (f) { return /option\.weight$/i.test(f.param); });
  var fColour = find(function (f) { return /custom\.filter_colour$/.test(f.param); });
  var fWho = find(function (f) { return /custom\.filter_who$/.test(f.param); });

  var BANDS = [
    { label: "Under ₹1,700", min: null, max: 1699 },
    { label: "₹1,700-2,500", min: 1700, max: 2499 },
    { label: "₹2,500-3,500", min: 2500, max: 3499 },
    { label: "₹3,500-5,000", min: 3500, max: 4999 },
    { label: "Above ₹5,000", min: 5000, max: null }
  ];
  function kgOf(v) {
    var s = String(v).toLowerCase(), n = parseFloat(s);
    if (isNaN(n)) return null;
    if (/kg/.test(s)) return n;
    if (/g/.test(s)) return n / 1000;
    return null;
  }
  var WGROUPS = [
    { label: "0.5 Kg", test: function (k) { return k === 0.5; } },
    { label: "1 Kg", test: function (k) { return k === 1; } },
    { label: "1.5 Kg", test: function (k) { return k === 1.5; } },
    { label: "2 Kg", test: function (k) { return k === 2; } },
    { label: "3 Kg and above", test: function (k) { return k >= 3; } }
  ];
  var WHO_SHOWN = ["Daughter", "Son", "Her", "Him"];
  var SWATCH = { White: "#fff", Pink: "#F4A7B9", Blue: "#6FA8DC", Brown: "#7B4B2A", Purple: "#9B6FC4", Red: "#D9534F", Green: "#5BAE6A", Yellow: "#F5D04C", Black: "#151515", Grey: "#9A9A9A", Orange: "#F28C38", Peach: "#F6C6A8", Cream: "#F3E5C8", Gold: "#D4AF37", Silver: "#C0C0C0", Ivory: "#FFFFF0", Beige: "#E8DCC4", Copper: "#B87333",
    Multicolour: "conic-gradient(#F4A7B9,#F5D04C,#5BAE6A,#6FA8DC,#9B6FC4,#F4A7B9)", "Black Gold": "linear-gradient(135deg,#151515 50%,#D4AF37 50%)" };

  // Groups shown in this layout, each with its options and current selection.
  var groups = [];
  if (fPrice) {
    var curMin = fPrice.min != null ? fPrice.min / 100 : null, curMax = fPrice.max != null ? fPrice.max / 100 : null;
    var bi = -1;
    BANDS.forEach(function (b, i) { if ((curMin != null || curMax != null) && (b.min == null ? curMin == null || curMin === 0 : curMin === b.min) && (b.max == null ? curMax == null : curMax === b.max)) bi = i; });
    groups.push({ key: "budget", name: "Budget", hint: "Cakes with a size in this price range. Pick one.", single: true,
      options: BANDS.map(function (b, i) { return { id: String(i), label: b.label, band: b }; }), sel: bi >= 0 ? [String(bi)] : [], filter: fPrice });
  }
  if (fWeight) {
    var wopts = WGROUPS.map(function (g) {
      var raw = fWeight.values.filter(function (v) { var k = kgOf(v.value); return k != null && g.test(k); });
      return { id: g.label, label: g.label, raw: raw.map(function (v) { return v.value; }), count: raw.reduce(function (a, v) { return a + (v.count || 0); }, 0), active: raw.some(function (v) { return v.active; }) };
    }).filter(function (o) { return o.raw.length && (o.count > 0 || o.active); });
    groups.push({ key: "weight", name: "Weight", hint: "Cakes that can be ordered in this size.", options: wopts, sel: wopts.filter(function (o) { return o.active; }).map(function (o) { return o.id; }), filter: fWeight });
  }
  function valueGroup(key, name, hint, f, keep) {
    if (!f) return;
    var opts = f.values.filter(function (v) { return (v.count > 0 || v.active) && (!keep || keep.indexOf(v.value) !== -1); })
      .map(function (v) { return { id: v.value, label: v.label, raw: [v.value], active: v.active }; });
    if (keep) opts.sort(function (a, b) { return keep.indexOf(a.id) - keep.indexOf(b.id); });
    if (!opts.length) return;
    groups.push({ key: key, name: name, hint: hint, options: opts, sel: opts.filter(function (o) { return o.active; }).map(function (o) { return o.id; }), filter: f });
  }
  valueGroup("colour", "Colour", "Main colour of the cake.", fColour);
  if (LAYOUT === "browse") {
    if (!AUDIENCE) valueGroup("who", "Who", "Who the cake is for.", fWho, WHO_SHOWN);
  }
  var committed = {};
  groups.forEach(function (g) { committed[g.key] = g.sel.slice(); });

  var SORTS = [
    { v: state.defaultSort || "manual", label: "Recommended", short: "" },
    { v: "price-ascending", label: "Price: low to high", short: "Low to high" },
    { v: "price-descending", label: "Price: high to low", short: "High to low" },
    { v: "best-selling", label: "Bestselling", short: "Bestselling" },
    { v: "created-descending", label: "Newest", short: "Newest" }
  ];
  var curSort = SORTS.filter(function (s) { return s.v === state.sort; })[0] || SORTS[0];

  /* ---------- URL building ---------- */
  function cleanUrl(keepFilters) {
    var u = new URL(location.href);
    ["page", "shown", "section_id"].forEach(function (k) { u.searchParams.delete(k); });
    if (!keepFilters) {
      var params = groups.map(function (g) { return g.filter; }).reduce(function (a, f) {
        if (f.type === "price_range") { a.push(f.minParam, f.maxParam); } else a.push(f.param); return a; }, []);
      params.forEach(function (p) { u.searchParams.delete(p); });
    }
    return u;
  }
  function urlFor(selection, sortV) {
    var u = cleanUrl(false);
    groups.forEach(function (g) {
      var s = selection[g.key] || [];
      if (!s.length) return;
      if (g.key === "budget") {
        var b = BANDS[+s[0]];
        if (b.min != null) u.searchParams.set(g.filter.minParam, b.min);
        if (b.max != null) u.searchParams.set(g.filter.maxParam, b.max);
      } else {
        g.options.forEach(function (o) { if (s.indexOf(o.id) !== -1) o.raw.forEach(function (r) { u.searchParams.append(g.filter.param, r); }); });
      }
    });
    u.searchParams.delete("sort_by");
    if (sortV && sortV !== SORTS[0].v) u.searchParams.set("sort_by", sortV);
    return u.toString();
  }
  function go(url) { root.classList.add("is-busy"); location.assign(url); }

  /* ---------- bar ---------- */
  function renderBar() {
    var track = $("[data-cc-chips]");
    track.innerHTML = groups.map(function (g) {
      var n = committed[g.key].length;
      return '<button type="button" class="cc-chip' + (n ? " is-on" : "") + '" data-cc-open="' + g.key + '" aria-pressed="' + (n ? "true" : "false") + '">' + esc(g.name) + (n ? " · " + n : "") + CHEV + "</button>";
    }).join("");
    var sortChip = $('[data-cc-open="sort"]');
    // Desktop chip shows the current sort ("Recommended"); the phone chip stays short ("Sort · Low to high").
    $("[data-cc-sort-label]").textContent = isDesktop() ? curSort.label : (curSort.short ? "Sort · " + curSort.short : "Sort");
    sortChip.classList.toggle("is-on", !!curSort.short);
    sortChip.setAttribute("aria-pressed", curSort.short ? "true" : "false");
    var any = groups.some(function (g) { return committed[g.key].length; });
    $("[data-cc-clear-desktop]").hidden = !any;
    var applied = $("[data-cc-applied]");
    var pills = [];
    groups.forEach(function (g) { committed[g.key].forEach(function (id) {
      var o = g.options.filter(function (x) { return x.id === id; })[0]; if (!o) return;
      pills.push('<button type="button" class="cc-pill" data-cc-remove="' + g.key + "|" + esc(id) + '">' + esc(o.label) + XICON + "</button>");
    }); });
    applied.innerHTML = pills.join("") + (pills.length ? '<button type="button" class="cc-link" data-cc-clear>Clear all</button>' : "");
    applied.hidden = !pills.length;
  }

  /* ---------- sheet / dropdown ---------- */
  var sheet = $("[data-cc-sheet]"), working = {}, activeTab = null, openKey = null, lastFocus = null;
  function openSheet(key, anchor) {
    lastFocus = document.activeElement;
    openKey = key;
    groups.forEach(function (g) { working[g.key] = committed[g.key].slice(); });
    activeTab = key === "sort" ? null : key;
    sheet.classList.toggle("is-sort", key === "sort");
    renderSheet();
    sheet.hidden = false;
    if (isDesktop() && anchor) {
      var r = anchor.getBoundingClientRect(), host = root.getBoundingClientRect();
      var w = key === "sort" ? 260 : 480;
      var x = key === "sort" ? r.right - host.left - w : r.left - host.left;
      x = Math.max(16, Math.min(x, host.width - w - 16));
      sheet.style.setProperty("--cc-x", x + "px");
      sheet.style.setProperty("--cc-y", (r.bottom - host.top + 8) + "px");
      sheet.style.top = "0px"; sheet.style.left = "0px";
    } else {
      document.documentElement.classList.add("cc-lock");
    }
    var first = sheet.querySelector(".cc-opt, .cc-sortrow, .cc-sheet__x");
    if (first) first.focus({ preventScroll: true });
  }
  function closeSheet() {
    sheet.hidden = true; openKey = null;
    document.documentElement.classList.remove("cc-lock");
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function renderSheet() {
    var title = $("[data-cc-sheet-title]"), tabs = $("[data-cc-tabs]"), body = $("[data-cc-body]"), foot = $("[data-cc-foot]");
    if (openKey === "sort") {
      title.textContent = "Sort by"; tabs.hidden = true; foot.hidden = true;
      body.innerHTML = '<div class="cc-sort" role="radiogroup" aria-label="Sort by">' + SORTS.map(function (s) {
        var on = s.v === curSort.v;
        return '<button type="button" class="cc-sortrow" role="radio" aria-checked="' + on + '" data-cc-sort="' + esc(s.v) + '"><span>' + esc(s.label) + '</span><span class="cc-radio" aria-hidden="true"></span></button>';
      }).join("") + "</div>";
      return;
    }
    var desk = isDesktop();
    var g = groups.filter(function (x) { return x.key === activeTab; })[0] || groups[0];
    title.textContent = desk ? g.name : "Filter cakes";
    tabs.hidden = desk; foot.hidden = false;
    tabs.innerHTML = groups.map(function (x) {
      var n = working[x.key].length;
      return '<button type="button" class="cc-tab" role="tab" aria-selected="' + (x.key === g.key) + '" data-cc-tab="' + x.key + '">' + esc(x.name) + "<small>" + (n ? n + " selected" : "") + "</small></button>";
    }).join("");
    body.innerHTML = '<p class="cc-hint">' + esc(g.hint) + '</p><div class="cc-opts">' + g.options.map(function (o) {
      var on = working[g.key].indexOf(o.id) !== -1;
      var dot = g.key === "colour" ? '<span class="cc-dot" style="background:' + (SWATCH[o.label] || "#ddd") + '"></span>' : "";
      return '<button type="button" class="cc-opt" aria-pressed="' + on + '" data-cc-opt="' + g.key + "|" + esc(o.id) + '">' + dot + esc(o.label) + "</button>";
    }).join("") + "</div>";
    $("[data-cc-sheet-clear]").textContent = desk ? "Clear" : "Clear all";
  }

  root.addEventListener("click", function (e) {
    if (e.target.closest("[data-cc-close]")) { closeSheet(); return; }
    var t = e.target.closest("button, a");
    if (!t || !root.contains(t)) return;
    if (t.matches("[data-cc-open]")) { e.preventDefault(); if (openKey === t.dataset.ccOpen && !sheet.hidden) closeSheet(); else openSheet(t.dataset.ccOpen, t); return; }
    if (t.matches("[data-cc-tab]")) { activeTab = t.dataset.ccTab; renderSheet(); return; }
    if (t.matches("[data-cc-opt]")) {
      var parts = t.dataset.ccOpt.split("|"), key = parts[0], id = parts.slice(1).join("|");
      var g = groups.filter(function (x) { return x.key === key; })[0];
      var arr = working[key], i = arr.indexOf(id);
      if (i !== -1) arr.splice(i, 1); else if (g.single) working[key] = [id]; else arr.push(id);
      renderSheet(); return;
    }
    if (t.matches("[data-cc-sheet-clear]")) {
      if (isDesktop() && activeTab) working[activeTab] = []; else groups.forEach(function (g) { working[g.key] = []; });
      renderSheet(); return;
    }
    if (t.matches("[data-cc-apply]")) { go(urlFor(working, curSort.v)); return; }
    if (t.matches("[data-cc-sort]")) { var v = t.dataset.ccSort; closeSheet(); if (v !== curSort.v) go(urlFor(committed, v)); return; }
    if (t.matches("[data-cc-remove]")) {
      var p = t.dataset.ccRemove.split("|"), sel = {};
      groups.forEach(function (g) { sel[g.key] = committed[g.key].slice(); });
      sel[p[0]] = sel[p[0]].filter(function (x) { return x !== p.slice(1).join("|"); });
      go(urlFor(sel, curSort.v)); return;
    }
    if (t.matches("[data-cc-clear]")) { var none = {}; groups.forEach(function (g) { none[g.key] = []; }); go(urlFor(none, curSort.v)); return; }
    if (t.matches("[data-cc-next]")) { e.preventDefault(); loadNext(); return; }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !sheet.hidden) closeSheet(); });
  window.addEventListener("resize", function () { if (!sheet.hidden && isDesktop()) closeSheet(); renderBar(); });
  // Desktop dropdown is anchored to the page, not the sticky bar, so close it when the page scrolls.
  window.addEventListener("scroll", function () { if (!sheet.hidden && isDesktop()) closeSheet(); }, { passive: true });

  /* ---------- earliest delivery ---------- */
  function fillEta(scope) {
    var els = $$(".cc-eta", scope || root);
    var E = window.CCSlotEngine, D = window.ccSlotData, C = window.ccClock;
    if (!E || !D || !C) { els.forEach(function (el) { el.style.display = "none"; }); return; }
    C.sync().then(function () {
      var now = C.now();
      var cities = Object.keys(D.cities || {}).map(function (k) { return E.normCity(D.cities[k]); }).filter(function (c) { return c && c.active; });
      els.forEach(function (el) {
        var val = el.querySelector(".cc-eta__val"), label = "", later = false;
        if (el.dataset.pan) { label = "48-72 hours"; later = true; }
        else {
          var rule = (D.rules && (D.rules[el.dataset.rule] || D.rules.designer)) || null;
          if (!rule || !cities.length) { el.style.display = "none"; return; }
          var best = null;
          cities.forEach(function (c) {
            var d = E.earliestDay(rule, c, now, { preorderFrom: el.dataset.pre || "" });
            if (!best || E.daysBetween(d, best) > 0) best = d;
          });
          var off = E.daysBetween(now.ymd, best);
          label = off === 0 ? "Today" : off === 1 ? "Tomorrow" : E.labelShort(best);
          later = off > 0;
        }
        val.textContent = label;
        el.classList.toggle("is-later", later);
        el.classList.add("is-ready");
      });
    });
  }
  fillEta();
  setInterval(function () { fillEta(); }, 5 * 60 * 1000);

  /* ---------- show more + back restore ---------- */
  var grid = $("[data-cc-grid]");
  var loading = false;
  var loadedPage = grid ? +grid.dataset.page : 1;
  var per = grid ? +grid.dataset.per : 24, total = grid ? +grid.dataset.total : 0;
  function storeKey() { var u = new URL(location.href); u.searchParams.delete("shown"); return "cc-col:" + u.pathname + u.search; }
  function setProgress() {
    var shown = $$(".cc-card", grid).length;
    var s = $("[data-cc-shown]"); if (s) s.textContent = shown;
    var bar = $("[data-cc-progress]"); if (bar && total) bar.style.width = Math.min(100, Math.round(shown * 100 / total)) + "%";
  }
  function loadNext() {
    var next = $("[data-cc-next]");
    if (!next || loading) return Promise.resolve(false);
    loading = true; next.classList.add("is-loading"); next.textContent = "Loading";
    var u = new URL(next.getAttribute("href"), location.origin);
    var page = +(u.searchParams.get("page") || loadedPage + 1);
    u.searchParams.set("section_id", SECTION);
    return fetch(u.toString(), { credentials: "same-origin" }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var items = doc.querySelectorAll("[data-cc-grid] > li");
      var frag = document.createDocumentFragment();
      items.forEach(function (li) { frag.appendChild(document.importNode(li, true)); });
      var firstNew = frag.firstElementChild;
      grid.appendChild(frag);
      loadedPage = page;
      var nn = doc.querySelector("[data-cc-next]");
      if (nn) { next.setAttribute("href", nn.getAttribute("href")); next.classList.remove("is-loading"); next.textContent = "Show more cakes"; }
      else next.remove();
      setProgress();
      var cu = new URL(location.href); cu.searchParams.set("shown", String(loadedPage));
      history.replaceState(history.state, "", cu.toString());
      fillEta(grid);
      loading = false;
      return firstNew;
    }).catch(function () { loading = false; next.classList.remove("is-loading"); next.textContent = "Show more cakes"; return false; });
  }
  // Remember where the shopper was when they open a cake.
  root.addEventListener("click", function (e) {
    var a = e.target.closest(".cc-card__link");
    if (a) { try { sessionStorage.setItem(storeKey(), JSON.stringify({ y: window.scrollY, page: loadedPage })); } catch (x) {} }
  }, true);
  // Coming back with ?shown=n: load the same pages again, then return to the same spot.
  (function restore() {
    var want = +(new URL(location.href).searchParams.get("shown") || 0);
    if (!grid || want <= loadedPage) return;
    var saved = null; try { saved = JSON.parse(sessionStorage.getItem(storeKey()) || "null"); } catch (x) {}
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    (function step() {
      if (loadedPage >= want || !$("[data-cc-next]")) {
        if (saved && typeof saved.y === "number") window.scrollTo({ top: saved.y, behavior: "instant" });
        return;
      }
      loadNext().then(function (ok) { if (ok) step(); });
    })();
  })();

  renderBar();
  setProgress();
})();
